export const firmware = {
  M3502PD: "M350 2PD + DSS - v{0}",
  M3503PD: "M350 3PD - v{0}",
  newFirmwareAvailable: "新的固件已发布：",
};
